/// <reference path="../_references.ts"/>
module App {
	export class AuthInterceptor {
		request: (config: any) => ng.IQService;
		requestError: (rejection: any) => ng.IPromise<never>;
		response: (response: any) => ng.IQService;
		responseError: (rejection: any) => ng.IPromise<never>;

		constructor(
			private $q: ng.IQService,
			private $injector: ng.auto.IInjectorService
		) {
			this.request = (config) => {
				return config || $q.when(config);
			};

			this.requestError = (rejection) => {
				return this.$q.reject(rejection);
			};

			this.response = (response) => {
				return response || $q.when(response);
			};

			this.responseError = (rejection) => {
				if(rejection.status === 401) {
					const loginService = <App.Login.LoginService> $injector.get('LoginService');

					loginService.destroySession();
				}

				return $q.reject(rejection);
			}
		}

		static factory() {
			let instance = ($q: ng.IQService, $injector: ng.auto.IInjectorService) =>
				new AuthInterceptor($q, $injector);

			instance.$inject = ['$http', '$injector'];

			return instance;
		}
	}

	angular.module('authInterceptor', [])
		.factory('AuthInterceptor', ['$q', '$injector', AuthInterceptor.factory()])
		.config(['$httpProvider', function($httpProvider: ng.IHttpProvider) {
			$httpProvider.interceptors.push('AuthInterceptor');
		}]);
}
